.root {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px 0 10px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-pill);
  background: transparent;
  color: var(--tuna-palette-text-primary);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.chip:hover {
  background-color: var(--tuna-palette-action-hover);
}

.chip:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.count {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-text-secondary);
  font-variant-numeric: tabular-nums;
}

/*
 * Selected: tinted fill and primary border, plus a check in place of the type icon (not color alone). The label is
 * text-primary: primary-main text on its own tint is 4.13:1 over a dark raised surface and 2.55:1 over grey-800
 * (Joni's phone audit, #3110 item 6). The border and tint carry the selected colour.
 */
.selected,
.selected:hover {
  border-color: var(--tuna-palette-primary-main);
  background-color: color-mix(in oklch, var(--tuna-palette-primary-main) 12%, transparent);
  color: var(--tuna-palette-text-primary);
  font-weight: 600;
}

.selected .count {
  color: inherit;
}

/* Phones: one row that scrolls sideways instead of wrapping */
@media (max-width: 599.95px) {
  .root {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Room for the focus outline inside the scroll box */
    padding: 3px;
    margin: -3px;
  }

  .root::-webkit-scrollbar {
    display: none;
  }

  .chip {
    flex: none;
    height: 36px;
  }
}
